import React, { useRef, useState } from 'react';
import styles from '../Header.module.scss';

import MenuPopper from 'components/MenuPopper/MenuPopper';

import { IconButton, MenuItem } from '@material-ui/core';

import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import DeleteIcon from '@material-ui/icons/Delete';
import CreateIcon from '@material-ui/icons/Create';
import { ReactComponent as CsvIcon } from 'assets/images/csvIcon.svg';

import {
  usePicklistDetailsActions,
  usePicklistDetailsSelector,
  usePicklistPermissions
} from 'hooks/Picklist';

import { fileDownload, wait } from 'helpers/AppHelpers';

import clsx from 'clsx';

export const MenuButtons = ({ onRemove, onEdit }) => {
  const anchorRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [isDisabled, setDisabled] = useState(false);

  const {
    currentPicklist: { id }
  } = usePicklistDetailsSelector();
  const { canEdit, canRemove } = usePicklistPermissions();
  const { getCsvResourceAction } = usePicklistDetailsActions();

  const clickMenu = () => setOpen(!open);

  const downloadCsv = () => {
    getCsvResourceAction({ picklistId: id }).then((file) => file?.link && fileDownload(file));
    setDisabled(true);
    wait(15000).then(() => setDisabled(false));
  };

  return (
    <div className={styles.menu_buttons}>
      <IconButton ref={anchorRef} className={styles.menu_buttons__btn} onClick={clickMenu}>
        <MoreHorizIcon />
      </IconButton>
      <MenuPopper
        open={open}
        setOpen={setOpen}
        anchorRef={anchorRef}
        classes={styles.menu_buttons__list}
        placement="bottom-end">
        {canEdit && (
          <MenuItem onClick={onEdit} className={styles.menu_buttons__list_item}>
            <CreateIcon />
            Edit picklist
          </MenuItem>
        )}
        {canRemove && (
          <MenuItem onClick={onRemove} className={styles.menu_buttons__list_item}>
            <DeleteIcon />
            Remove picklist
          </MenuItem>
        )}
        <MenuItem
          onClick={downloadCsv}
          className={clsx(isDisabled && styles.disabled, styles.menu_buttons__list_item)}>
          <CsvIcon />
          Download CSV file
        </MenuItem>
      </MenuPopper>
    </div>
  );
};
